<template>
  <div class="users-list-page">
    <div class="global-header-wrap">
      <div class="user-header-left">
        <div class="left-part">
          <span>用户ID</span>
          <div class="listSearch">
            <el-input
              v-model="userId"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('userId')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>目标</span>
          <div class="listSearch">
            <el-input
              v-model="target"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('target')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>{{ $t("user.mac") }}</span>
          <div class="listSearch">
            <el-input
              v-model="mac"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('mac')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <!-- <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'add' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("user.addUser") }}
        </button>
      </div> -->
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable :tableProps="tableProps" :tableData="tableData" />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
        :pageSizes="true"
      />
    </el-card>
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";

export default {
  name: "Users",
  components: {
    AppTable,
    Pagination
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "userId",
          label: "用户ID"
        },
        {
          prop: "mac",
          label: "设备MAC"
        },
        {
          prop: "level",
          label: "登记"
        },
        {
          prop: "target",
          label: "目标"
        },
        {
          prop: "useinfo.enable",
          label: "是否可用",
          obj: true
        },
        {
          prop: "useinfo.allTimes",
          label: "总次数",
          obj: true
        },
        {
          prop: "useinfo.dayTimes",
          label: "当天使用次数",
          obj: true
        },
        {
          prop: "useinfo.lastTime",
          label: "最近使用时间",
          obj: true
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      userId: "",
      mac: "",
      target: "",
      paramsList: { limit: 20, page: 1 }
    };
  },
  methods: {
    usePowersList() {
      this.$http
        .usePowersList(this.paramsList)
        .then(res => {
          this.total = res.data.count;
          this.tableData = res.data.results;
        })
        .catch(() => {});
    },

    search() {
      this.paramsList.page = 1;

      if (this.userId) {
        this.paramsList.userId = this.userId;
      } else {
        delete this.paramsList.userId;
      }

      if (this.target) {
        this.paramsList.target = this.target;
      } else {
        delete this.paramsList.target;
      }

      if (this.mac) {
        this.paramsList.mac = this.mac;
      } else {
        delete this.paramsList.mac;
      }

      this.usePowersList();
    },

    clearSearch(type) {
      switch (type) {
        case "userId":
          this.userId = "";
          delete this.paramsList.userId;
          break;
        case "target":
          this.target = "";
          delete this.paramsList.target;
          break;
        case "mac":
          this.mac = "";
          delete this.paramsList.mac;
          break;
        default:
          break;
      }
      this.paramsList.page = 1;
      this.usePowersList();
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.usePowersList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.usePowersList();
    }
  },
  mounted() {
    this.usePowersList();
  }
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.users-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .user-header-left {
    width: calc(100% - 120px);
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 150px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
